(function(scope){
'use strict';
const family={elegant:'Brittany Signature',classic:'Times New Roman',modern:'Arial'};
function create(fonts){
 function design(row,nameStyle='elegant',detailStyle='classic',layout='Hartje en takje'){
  const paths=[];let tooSmall=false;const missing=new Set();
  function text(str,cy,maxw,maxh,style){
   str=String(str||'').normalize('NFC');if(!str)return;
   const f=fonts[style];for(const c of str){const base=c.normalize('NFD').replace(/[\u0300-\u036f]/g,'');if(!f.hasChar(c)||(base!==c&&base.length===1&&f.charToGlyphIndex(c)===f.charToGlyphIndex(base)))missing.add(c);}
   const raw=f.getPath(str,0,0,1000,{kerning:true}),b=raw.getBoundingBox();
   if(!Number.isFinite(b.x1)||b.x2===b.x1)return;
   const scale=Math.min(maxw/(b.x2-b.x1),maxh/(b.y2-b.y1),style==='elegant'?1:.132);
   if((b.y2-b.y1)*scale/1200*95<1.65)tooSmall=true;
   const dx=600-(b.x1+b.x2)*scale/2,dy=cy-(b.y1+b.y2)*scale/2;
   const path=new scope.opentype.Path();
   path.commands=raw.commands.map(c=>{const r={type:c.type};for(const k of Object.keys(c)){if(k==='type')continue;r[k]=c[k]*scale+(k.startsWith('x')?dx:dy);}return r;});
   paths.push(path.toPathData(4));
  }
  text(row.name,384,804,180,nameStyle);text(row.second,672,744,67,detailStyle);text(row.third,780,672,60,detailStyle);
  if(layout==='Naam met hartje'||layout==='Hartje en takje')paths.push('M600 562 C590 551 570 536 570 523 C570 504 591 502 600 516 C609 502 630 504 630 523 C630 536 610 551 600 562Z');
  if(layout==='Naam met takje'||layout==='Hartje en takje'){
   paths.push('M424 890 Q600 970 776 890 L778 894 Q600 976 422 894Z');
   for(let i=0;i<8;i++){const x=465+i*38,y=924-40*Math.pow((x-600)/176,2),s=i%2?-1:1;paths.push(`M${x} ${y} C${x-22} ${y+s*8} ${x-25} ${y+s*32} ${x-20} ${y+s*40} C${x+4} ${y+s*28} ${x+6} ${y+s*10} ${x} ${y}Z`);}
  }
  return {paths,tooSmall,missing:[...missing],family:{name:family[nameStyle],details:family[detailStyle]}};
 }
 function svg(result){return `<svg xmlns="http://www.w3.org/2000/svg" width="95mm" height="95mm" viewBox="0 0 1200 1200"><g fill="#000">${result.paths.map(d=>`<path d="${d}"/>`).join('')}</g></svg>`;}
 return {design,svg,family};
}
scope.DLSCoasterVector={create,family};
})(typeof window==='undefined'?globalThis:window);

